import type { HouseholdMember } from '@hewey/shared'

// Display helpers for household members — assignee chips and pickers, the
// Settings members list. A member may have a null displayName (registered but
// not yet onboarded), so both fall back gracefully.
export const memberLabel = (m: HouseholdMember): string =>
	m.displayName?.trim() || 'Member'

export const initialFor = (m: HouseholdMember): string =>
	(m.displayName?.trim()[0] ?? '?').toUpperCase()
